import React, { useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import { queries } from '../../graphql/graphql';

import LoggedLayout from '../../components/Layouts/LoggedLayout';
import GuestLayout from '../../components/Layouts/GuestLayout';
import { ViewContractor } from '../../components/Contractors/View';
import actions from '../../store/actions/actions';
import _ from 'lodash';
import _s from './index.less';

export const FEATURES_PLAN = {
  A6oFIkaldb8L: 'Garage',
  '6eYkBkBkTKn5': 'Additional storage space',
  MqtkTwnnsj9d: 'Patio/yard access'
};

export const ViewPlanItem = ({ image, photos = [] }) => {
  const [primaryImage] = _.filter(photos, p => !!p.isPrimary);
  if (primaryImage) {
    image = primaryImage.original;
  }

  return (
    <>
      <Helmet>
        <meta property="og:image" key="og:image" content={image} />
      </Helmet>
      <img src={image} alt="Configure" className={_s.imageView3d} />
    </>
  );
};

const ViewPlan = props => {
  const { plan, mapId } = props;
  const { loading, data = {}, refetch } = useQuery(queries.CONTRACTOR_VIEW, {
    variables: { id: plan.contractorId }
  });
  const { contractor } = data;

  useEffect(() => {
    refetch();
  }, [data]);

  return loading ? (
    <LoadingOutlined style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }} />
  ) : (
    <ViewContractor
      setConsumerEmail={props.setConsumerEmail}
      consumer={props.consumer}
      plan={plan}
      mapId={mapId}
      contractor={contractor}
      PlanComponent={ViewPlanItem}
      user={props.user}
    />
  );
};

const ViewPlanWrapper = props => {
  const { params } = props.match;
  const planId = params.id;
  const mapId = params.mapId || '';

  const { loading, data, refetch } = useQuery(queries.PLAN_VIEW, { variables: { id: planId } });
  useEffect(() => {
    refetch();
  }, [data]);

  if (!loading && !data) return <div>Plan not found.</div>;

  return (
    <div
      style={{
        display: 'block',
        // width: '100vw',
        // minHeight: '100vh',
        padding: 0,
        marginTop: '3px',
        background: '#ffffff'
      }}
    >
      {loading ? (
        <LoadingOutlined
          style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}
        />
      ) : (
        <ViewPlan
          setConsumerEmail={props.setConsumerEmail}
          plan={data.plan}
          consumer={props.consumer}
          mapId={mapId}
          user={props.user}
        />
      )}
    </div>
  );
};

const View = props => {
  return (
    <>
      {props.loggedIn ? (
        <LoggedLayout>
          <ViewPlanWrapper {...props} />
        </LoggedLayout>
      ) : (
        <GuestLayout>
          <ViewPlanWrapper {...props} />
        </GuestLayout>
      )}
    </>
  );
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ setConsumerEmail: actions.setConsumerEmail }, dispatch);
};

const mapStateToProps = state => {
  return {
    loggedIn: state.auth.loggedIn,
    consumer: state.consumer,
    user: state.auth.user
  };
};

View.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  consumer: PropTypes.object
};

const connectedViewPage = connect(mapStateToProps, mapDispatchToProps)(View);

export default connectedViewPage;
